import { Box } from "@mui/material";
import { dateTimeFormatter } from "src/utils/date";
import { GridColDef } from "@mui/x-data-grid-premium";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import ByzDataGridToolbar from "src/components/core-components/mui/data-grid/toolbar";
import { useTranslate } from "src/locales";
import type { AllRequestRow } from "../types";
import { REQUEST_LIST_GRID_COMPACT_SX } from "../constants";

interface AllRequestsGridProps {
  rows: AllRequestRow[];
  loading?: boolean;
  onRowSelect?: (row: AllRequestRow) => void;
}

export default function AllRequestsGrid({
  rows,
  loading = false,
  onRowSelect,
}: AllRequestsGridProps) {
  const { t } = useTranslate();

  // Warning modal state


  const columns: GridColDef<AllRequestRow>[] = [
    {
      field: "actionName",
      headerName: t("request-list.columns.action-name", "default", { defaultValue: "İşlem Adı" }),
      flex: 1,
      minWidth: 120,
    },
    {
      field: "actionDate",
      headerName: t("request-list.columns.action-date", "default", { defaultValue: "İşlem Tarihi" }),
      width: 150,
      valueFormatter: (value) => dateTimeFormatter(value, "dd.MM.yyyy HH:mm:ss"),
    },
    {
      field: "note",
      headerName: t("request-list.columns.note", "default", { defaultValue: "Not" }),
      width: 100,
    },
    {
      field: "quantity",
      headerName: t("request-list.columns.quantity", "default", { defaultValue: "Sayı" }),
      width: 80,
      type: "number",
    },
    {
      field: "pacsStatus",
      headerName: t("request-list.columns.pacs-status", "default", { defaultValue: "PACS Durumu" }),
      width: 120,
    },
    {
      field: "consultationNote",
      headerName: t("request-list.columns.consultation-note", "default", { defaultValue: "Konsültasyon Notu" }),
      flex: 1,
      minWidth: 140,
    },
    {
      field: "doctorName",
      headerName: t("request-list.columns.doctor-name", "default", { defaultValue: "Doktor Adı" }),
      width: 140,
    },
    {
      field: "departmentName",
      headerName: t("request-list.columns.department-name", "default", { defaultValue: "Bölüm Adı" }),
      width: 140,
    },
    {
      field: "requestStatus",
      headerName: t("request-list.columns.request-status", "default", { defaultValue: "İstek Durumu" }),
      width: 120,
    },
    {
      field: "requestDate",
      headerName: t("request-list.columns.request-date", "default", { defaultValue: "İstek Tarihi" }),
      width: 150,
      valueFormatter: (value) => dateTimeFormatter(value, "dd.MM.yyyy HH:mm:ss"),
    },
    {
      field: "serviceType",
      headerName: t("request-list.columns.service-type", "default", { defaultValue: "Hizmet Tipi" }),
      width: 120,
    },
    {
      field: "prdId",
      headerName: "PRD_ID",
      width: 90,
    },
  ];

  return (
    <Box sx={{ width: "100%", flex: 1, minHeight: 400 }}>
      <ByzMuiDataGrid
        rows={rows}
        columns={columns}
        checkboxSelection
        disableRowSelectionOnClick
        pagination
        pageSizeOptions={[10]}
        initialState={{ 
          density: "compact",
          pagination: { paginationModel: { pageSize: 10 } }
        }}
        loading={loading}
        customToolbar={() => (
          <ByzDataGridToolbar
            searchPlaceholder={t("request-list.search", "default", { defaultValue: "Ara..." })}
            searchIconColor="#1E88E5"
          />
        )}
        whiteGrid
        headerWhite
        getRowId={(row) => row.id}
        onRowClick={(params) => onRowSelect?.(params.row)}
        sx={{
          ...REQUEST_LIST_GRID_COMPACT_SX,
          "& .MuiDataGrid-row": {
            cursor: onRowSelect ? "pointer" : "default",
          },
        }}
      />

    </Box>
  );
}
